export const QUALIFIED_SHARED_DIVIDENDS_REPORT_ACCEPTED = "QUALIFIED_SHARED_DIVIDENDS_REPORT_ACCEPTED";
export const QUALIFIED_SHARED_DIVIDENDS_REPORT_REJECTED = "QUALIFIED_SHARED_DIVIDENDS_REPORT_REJECTED";
export const QUALIFIED_SHARED_DIVIDENDS_REPORT_SNOOZED = "QUALIFIED_SHARED_DIVIDENDS_REPORT_SNOOZED";
